<template>
    <div
        v-if="terms.length > 0"
        class="product-filter-group mb-1"
    >
        <button 
            data-toggle="collapse" 
            aria-expanded="false" 
            role="button"
            class="product-filter-group__button collapsed mb-1"
            :data-target="'#filter-group--'+taxonomy"
            :aria-controls="'filter-group--'+taxonomy"
            >{{name}}</button>
        <div :id="'filter-group--'+taxonomy" class="collapse" :class="{long: terms.length > 10}">
            <ProductFilter
                v-for="term in terms"
                v-bind="term"
                :key="term.id"
                :handle="taxonomy"
            />
        </div>        
    </div>
</template>
<script>
import ProductFilter from "./ProductFilter.vue";
export default {
    props : {
        name : String,
        terms : {
            type: Array,
            default: () => []
        },
        taxonomy : String
    },
    components : {
        ProductFilter
    }
}
</script>
<style lang="scss">
    .product-filter-group {

        .long {
            max-height: 280px;
            overflow-y: scroll;
        }
    }
</style>